<dx-select-box
  class="projection-method-select__control"
  [dataSource]="methodOptions"
  [value]="value()"
  valueExpr="value"
  displayExpr="label"
  [width]="150"
  [dropDownOptions]="methodDropDownOptions"
  stylingMode="outlined"
  itemTemplate="methodItem"
  [disabled]="disabled()"
  [attr.aria-label]="'Projection method'"
  (onValueChanged)="onValueChanged($event)"
  (onClosed)="closeMethodPopoverNow()"
>
  <div *dxTemplate="let option of 'methodItem'">
    <!-- mousemove feeds the safety triangle its apex: without the pointer's
         previous position there is no direction to infer, and every item crossed
         on the way to the popover would steal it. -->
    <div
      class="projection-method-select__method-item"
      (mousemove)="onMethodItemPointerMove($event)"
      (mouseenter)="openMethodPopover($event, option)"
      (mouseleave)="closeMethodPopover()"
    >
      <div class="projection-method-select__method-item-head">
        <span class="projection-method-select__method-label">{{ option.label }}</span>
        <span
          class="projection-method-select__method-mape"
          [class.projection-method-select__method-mape--best]="option.value === 'credibility'"
          [class.projection-method-select__method-mape--worst]="option.value === 'runrate'"
        >
          ±{{ option.mape | number: "1.1-2" }}%
        </span>
      </div>
      <div class="projection-method-select__method-tagline">{{ option.tagline }}</div>
    </div>
  </div>
</dx-select-box>

<!-- Explains an option at the moment of choosing. Anchors to items inside the select box's dropdown overlay. -->
<dx-popover
  [(visible)]="isMethodPopoverVisible"
  [target]="methodPopoverTarget"
  [hideOnOutsideClick]="false"
  [width]="430"
  position="left"
>
  <div *dxTemplate="let data of 'content'">
    @if (methodPopoverOption; as option) {
      <div
        class="projection-method-select__popover-host"
        (mouseenter)="holdMethodPopover()"
        (mouseleave)="closeMethodPopover()"
      >
        <ag-shr-projection-method-help [option]="option" />
      </div>
    }
  </div>
</dx-popover>
